/**
 * Un mode de règlement de la boutique
 */
export class BoutiqueModeReglement {
    /**
     * Constructeut de l'objet
     * @param row Paramètres du constructeur
     */
    constructor(row) {
        if (row) {
            const { idModeReglement, libelle, actif } = row;
            this.idModeReglement = idModeReglement;
            this.libelle = libelle;
            this.actif = actif;
        }
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQm91dGlxdWVNb2RlUmVnbGVtZW50LmNsYXNzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiQm91dGlxdWVNb2RlUmVnbGVtZW50LmNsYXNzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBQ0gsTUFBTSxPQUFPLHFCQUFxQjtJQWdCakM7OztPQUdHO0lBQ0gsWUFBbUIsR0FBbUM7UUFDckQsSUFBSSxHQUFHLEVBQUU7WUFDUixNQUFNLEVBQUUsZUFBZSxFQUFFLE9BQU8sRUFBRSxLQUFLLEVBQUUsR0FBRyxHQUFHLENBQUM7WUFDaEQsSUFBSSxDQUFDLGVBQWUsR0FBRyxlQUFlLENBQUM7WUFDdkMsSUFBSSxDQUFDLE9BQU8sR0FBRyxPQUFPLENBQUM7WUFDdkIsSUFBSSxDQUFDLEtBQUssR0FBRyxLQUFLLENBQUM7U0FDbkI7SUFDRixDQUFDO0NBQ0QifQ==